<template>
  <div class="category">
    <div class="heading" @click="handleDropDownClick">
      <h4 class="title">{{ filtername }}</h4>
      <span
        :class="configuration[filtername].expanded ? 'up-arrow' : 'down-arrow'">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="inherit"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.585 8.58496L12 13.17L7.415 8.58496L6 9.99996L12 16L18 9.99996L16.585 8.58496Z"
            fill="inherit" />
        </svg>
      </span>
    </div>
    <div
      v-if="configuration[filtername].expanded"
      class="date-content content datepicker">
      <div class="filter-container-contents-datepicker">
        <date-picker
          name="fromDate"
          :value="fromDate"
          placeholder="Choose from Date"
          format="DD-MMM-YYYY"
          @change="handleDateClick($event, 'fromDate')" />
        <div class="filter-container-contents-datepicker-text">
          <h6>To</h6>
        </div>
        <date-picker
          name="toDate"
          :value="toDate"
          placeholder="Choose To Date"
          format="DD-MMM-YYYY"
          :disabled="!fromDate && !toDate"
          @change="handleDateClick($event, 'toDate')" />
        <div class="filter-container-contents-datepicker-button-today">
          <button @click="handleButtonClick('Today')">Today</button>
        </div>
        <div class="filter-container-contents-datepicker-button-sevendays">
          <button @click="handleButtonClick('Last 7 Days')">Last 7 days</button>
        </div>
        <div class="filter-container-contents-datepicker-button-month">
          <button @click="handleButtonClick('This Month')">Last Month</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Importing Date Picker
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

// Importing Date Fns
import { format } from "date-fns";

export default {
  name: "DateFilter",
  components: {
    DatePicker,
  },
  props: {
    filtername: {
      type: String,
      required: true,
    },
    configuration: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    fromDate() {
      return this.value[0];
    },
    toDate() {
      return this.value[1];
    },
  },
  methods: {
    handleDropDownClick() {
      this.$emit("handleFilterToggle", `${this.filtername}`);
    },
    handleDate(date) {
      let [dayFrom, monthFrom, yearFrom] = date.split("/");
      return format(
        new Date(`${monthFrom}/${dayFrom}/${yearFrom}`),
        "dd-MMM-yyyy"
      );
    },
    handleDateClick(date, name) {
      this.$emit("handleFilterChange", {
        type: "date",
        name: name,
        filterName: this.filtername,
        value: date,
      });
    },
    handleButtonClick(value) {
      this.$emit("handleFilterChange", {
        type: "date",
        filterName: this.filtername,
        dateText: value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  display: flex;
  flex-direction: column;
  width: 196px;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  padding: 12px;

  &-display {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &-title {
      margin: 0;
      font-size: 14px;
      font-family: "MaerskText Regular";
      color: #000000;
    }

    &-up-arrow {
      transform: rotate(180deg);
    }
  }

  &-contents {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 8px;

    &-datepicker {
      padding: 10px 0;

      .mx-datepicker {
        width: 100%;
      }

      &-text {
        margin: 10px 0;
        display: flex;
        justify-content: center;

        h6 {
          margin: 0;
          padding: 0;
        }
      }

      &-button-today {
        margin-top: 16px;
      }

      button {
        width: 100%;
        background-color: var(--search-bar-bg);
        font-family: "MaerskText Regular";
        font-size: 12px;
        padding: 6px;
        border-radius: 4px;
        margin: 4px 0;
        color: var(--primary-text);
        text-align: center;
        cursor: pointer;
        border: 0;
      }

      button:hover {
        background-color: var(--active-tab);
        color: var(--white);
      }
    }
  }
}
</style>
